/**
 * Quem enxerga só o que é dele: a carteira, os leads e as oportunidades que
 * alcança. Espelha `RESTRICTED_VIEWER_TYPES` do backend
 * (`libs/common/permissions/restricted-viewer.util.ts`).
 *
 * O usuário de IA (`AI`, ver docs/ai-user.md) é restrito como o funcionário:
 * ele trabalha na carteira e no funil dele. É por isto que o `isEmployee` da
 * sessão também vale para ele — é esse flag que liga a visão restrita (abas
 * Meus/Triagem/Todos do atendimento e afins).
 */
export function isAiUserType(userType?: string | null): boolean {
    return userType === 'AI'
}
